import React, { useRef } from 'react';
import DatePicker from 'react-datepicker';
import { FormField } from '@xingternal/text-field';
import { FormikErrors } from 'formik';

import styles from './styles.css';

type InputSize = 'small' | 'medium' | 'large';
export interface DateFormFieldProps {
  value: Date;
  onChange: (date: Date, event: React.ChangeEvent) => void;
  dateFormat?: string;
  disabled?: boolean;
  error?: FormikErrors<Date>;
  name: string;
  label?: string;
  size?: InputSize;
  data?: {
    [propName: string]: string;
  };
}

export const DateFormField = ({
  value,
  name,
  onChange,
  dateFormat = 'dd.MM.yyyy',
  disabled = false,
  error = '',
  label = '',
  size = 'medium',
  data = {},
}: DateFormFieldProps): React.ReactElement => {
  const datePicker = useRef<DatePicker>(null);

  const closeDatepicker = (): void => {
    datePicker.current.setOpen(false);
  };

  return (
    <DatePicker
      ref={datePicker}
      selected={value}
      onChange={onChange}
      dateFormat={dateFormat}
      disabled={disabled}
      customInputRef="id"
      popperClassName={styles.datePickerPopper}
      id={name}
      customInput={
        <FormField
          data-cy={data.cy}
          disabled={disabled}
          error={!!error}
          label={label}
          helperText={error as string}
          onBlur={closeDatepicker}
          size={size}
        />
      }
    />
  );
};
